/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for TimesheetTypeResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetTimesheetTypeByIdResponse, GetTimesheetTypesResponse, GetTimesheetTypeSelectResponse } from "../models";

@Injectable({ providedIn: "root" })
export class TimesheetTypeResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getTimesheetTypeById(id: Signal<number> | number, resourceOptions: HttpResourceOptions<GetTimesheetTypeByIdResponse, unknown> & { defaultValue: NoInfer<GetTimesheetTypeByIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTimesheetTypeByIdResponse>;
    getTimesheetTypeById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetTimesheetTypeByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTimesheetTypeByIdResponse | undefined>;
    getTimesheetTypeById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetTimesheetTypeByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTimesheetTypeByIdResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/TimesheetType/${typeof id === 'function' ? id() : id}`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getTimesheetTypes(resourceOptions: HttpResourceOptions<GetTimesheetTypesResponse, unknown> & { defaultValue: NoInfer<GetTimesheetTypesResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTimesheetTypesResponse>;
    getTimesheetTypes(resourceOptions?: HttpResourceOptions<GetTimesheetTypesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTimesheetTypesResponse | undefined>;
    getTimesheetTypes(resourceOptions?: HttpResourceOptions<GetTimesheetTypesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTimesheetTypesResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/TimesheetType`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getTimesheetTypeSelect(resourceOptions: HttpResourceOptions<GetTimesheetTypeSelectResponse, unknown> & { defaultValue: NoInfer<GetTimesheetTypeSelectResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTimesheetTypeSelectResponse>;
    getTimesheetTypeSelect(resourceOptions?: HttpResourceOptions<GetTimesheetTypeSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTimesheetTypeSelectResponse | undefined>;
    getTimesheetTypeSelect(resourceOptions?: HttpResourceOptions<GetTimesheetTypeSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTimesheetTypeSelectResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/TimesheetType/Select`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
